module.exports = __webpack_public_path__ + "static/logo.63280937.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 561
// module chunks = 168707334958949